import React from "react";

const Footer = () => {
  return (
    <footer className="bg-black text-center py-6 text-gray-400">
      © {new Date().getFullYear()} LiquorLuxe. All Rights Reserved.
    </footer>
  );
};

export default Footer;
